import { z } from 'zod';

/**
 * The bell (ops insights Phase 5a): one person's notifications, newest first, a page at a
 * time. Not the shared `listInput`: the bell has one order and nothing to search.
 */
export const notificationListInput = z.object({
  limit: z.number().int().min(1).max(50).default(20),
  offset: z.number().int().min(0).default(0),
});
export type NotificationListInput = z.infer<typeof notificationListInput>;

/** Mark these read. Ids that are not the caller's, or already read, are passed over. */
export const notificationMarkReadInput = z.object({
  ids: z.array(z.string().uuid()).min(1).max(100),
});
export type NotificationMarkReadInput = z.infer<typeof notificationMarkReadInput>;
